module.exports = __webpack_public_path__ + "static/media/user-ninja.63a1d667.svg";